import { Box } from "@mui/material"
import { getTeamInfoById, getVisualTimer } from "../../../../../../../sports/genericUtils.js"

import BoxItem from "../../../items/fragments/BoxItem.js";
import TypoTimer from "../../../items/fragments/TypoTimer.js";
import TypoTitle from "../../../items/fragments/TypoTitle.js";
import TypoText from "../../../items/fragments/TypoText.js";
import { START_STOP_PERIODS_EVENTS_LABELS } from "../../../../data/gameEvents.js";

const getDefaultTitleForEvent = ({ discipline, eventType }) => {
  const list = START_STOP_PERIODS_EVENTS_LABELS?.[discipline];
  if (!Array.isArray(list)) return undefined;

  return list.find(e => e.type === eventType)?.label;
};

const GenericCommentaire = ({ item, match, icon }) => {
  const { comment, title, target, period, timer} = item.detail;

  const visualTimer = getVisualTimer(timer, period, match.discipline);
  const teamDetail = getTeamInfoById(target, match);

  const betterTitle =
    title ||
    getDefaultTitleForEvent({
          discipline: match.discipline,
          eventType: item.type,
        });

  return (
    <BoxItem>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <TypoTimer timer={visualTimer} lisere={teamDetail ? teamDetail.color : "#4973AE"} />
        <img src={icon} alt="Player Icon" style={{ width: 40, height: 40 }} />
      </Box>

      <Box sx={{ display: "flex", alignItems: "flex-start", marginTop: "8px", position: "relative" }}>
        <Box sx={{ paddingLeft: "8px" }}>
          <TypoTitle title={betterTitle || ''} />
          <TypoText text={comment} />
        </Box>
      </Box>
    </BoxItem>
  );
};

export default GenericCommentaire;